const defaultFieldCSS = {
    position: "absolute",
    
    boxSizing: "border-box",
    padding: "0cm 0.2cm",
    
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color:"black",

    overflow: "hidden",
    overflowWrap: "anywhere"
}

export default defaultFieldCSS;